import { DLOTabItem } from '../../../components/DLOTabNavigation';

export const SCHEDULE_SETTING_TABS: DLOTabItem[] = [
  { id: 'forecasted', label: 'Forecasted Volume Data' },
  { id: 'actual', label: 'Actual Volume Data' },
];

export const DAY_MAPPING = {
  1: 'sun', 2: 'mon', 3: 'tue', 4: 'wed', 5: 'thu', 6: 'fri', 7: 'sat'
} as const;

export const DAY_MAPPING_REVERSE = {
  'sun': 1,
  'mon': 2,
  'tue': 3,
  'wed': 4,
  'thu': 5,
  'fri': 6,
  'sat': 7,
} as const;
